'use client';

import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import MarketingVideoEmbed from './MarketingVideoEmbed';
import NewsArticleImageCarousel from './NewsArticleImageCarousel';

const proseSx = {
  lineHeight: 1.7,
  maxWidth: '100%',
  minWidth: 0,
  overflowWrap: 'break-word',
  wordBreak: 'break-word',
  flexShrink: 0,
  '& p': { mb: 2 },
  '& h2, & h3, & h4': {
    fontWeight: 600,
    mt: 3,
    mb: 1.5,
  },
  '& a': {
    color: 'inherit',
    textDecoration: 'underline',
    '&:hover': { opacity: 0.7 },
  },
};

export default function NewsArticleBody({
  proseHtml,
  videos = [],
  images = [],
  title,
  carouselFillHeight = false,
}) {
  if (!proseHtml && videos.length === 0 && images.length === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        minWidth: 0,
        maxWidth: '100%',
        display: 'flex',
        flexDirection: 'column',
        flex: carouselFillHeight ? 1 : undefined,
        minHeight: carouselFillHeight ? 0 : undefined,
        overflow: carouselFillHeight ? 'hidden' : undefined,
      }}
    >
      {proseHtml ? <Box sx={proseSx} dangerouslySetInnerHTML={{ __html: proseHtml }} /> : null}

      {videos.map((video, index) => (
        <MarketingVideoEmbed
          key={`${video.src}-${index}`}
          src={video.src}
          title={`${title} video`}
        />
      ))}

      <NewsArticleImageCarousel images={images} title={title} fillHeight={carouselFillHeight} />
    </Box>
  );
}

NewsArticleBody.propTypes = {
  proseHtml: PropTypes.string,
  videos: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string.isRequired,
    }),
  ),
  images: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string.isRequired,
      alt: PropTypes.string,
      photographerCredit: PropTypes.string,
    }),
  ),
  title: PropTypes.string.isRequired,
  carouselFillHeight: PropTypes.bool,
};
